export default __webpack_public_path__ + "static/media/1883.53c0cf0f.png";